export interface IAppContentDto {
  contentType: string;
  contentName: string;
  details: AppContentDetailDTO;
}
export class AppContentDetailDTO {
  title!: object;
  summary!: object;
  fullText!: object;
}
